import React from "react";
import { Link, LinkProps } from "react-router-dom";
import theme from "@monorepo/styles/theme";
import { styled, SxProps } from "@mui/material/styles";

const SLink = styled(Link)(() => ({
  cursor: "pointer",
  textDecoration: "none",
}));
const SRegistrationLink = styled(Link)(() => ({
  cursor: "pointer",
  color: theme.palette.primary.main,
  textAlign: "left",
  textDecoration: "underline",
  fontSize: theme.typography.body1.fontSize,
  display: "block",
  alignSelf: "flex-start",
  marginRight: "auto",
}));

interface ILinkProps {
  to: LinkProps["to"];
  sx?: SxProps;
  onClick?: () => void;
}

export const StyledLink: React.FC<ILinkProps> = ({ children, to, sx, onClick }) => {
  return (
    <SLink onClick={onClick} sx={sx} to={to}>
      {children}
    </SLink>
  );
};

export const StyledRegistrationLink: React.FC<ILinkProps> = ({ children, to, sx, onClick }) => {
  return (
    <SRegistrationLink onClick={onClick} sx={sx} to={to}>
      {children}
    </SRegistrationLink>
  );
};
